import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails, FormControl } from '@mui/material';

import { ModalButtonRow } from '../ModalButtonRow';

import {
  TEXT,
  FULL_WIDTH,
  DOUBLE_FIELDS_WRAPPER,
  SINGLE_FIELD_WRAPPER,
} from '../../../constants/Dashboard';

import {
  NET_WORTH_MODAL,
  TRIPLE_FIELDS_WRAPPER,
  NET_WORTH_ADDING_PADDING,
  ASSETS,
  TOTAL_ASSETS,
  LIABILITIES,
  TOTAL_LIABILITIES,
  NET_WORTH,
} from '../../../constants/Dashboard/Asset-NetWorth';

import { getFieldType } from '../../../utils';

import './AssetWorthModalContent.css';

export const AssetWorthModalContent = ({ handleClose, onConfirm, user, assetsAndNetWorthInfo }) => {
  const [assetWorthModalInfoState, setAssetWorthModalInfoState] = useState(assetsAndNetWorthInfo);
  const [expandedSection, setExpandedSection] = useState(ASSETS);

  // TO DO - Better Naming Conventions and refactor the logic here to make cleaner
  const getValue = (curSection, curElement) => {
    if (curSection === NET_WORTH) {
      return assetWorthModalInfoState[NET_WORTH][curElement.text];
    }

    return [TOTAL_ASSETS, TOTAL_LIABILITIES].includes(curElement?.text)
      ? assetWorthModalInfoState?.[curSection]?.[curElement?.text]
      : assetWorthModalInfoState?.[curSection]?.[curElement.label];
  };

  return (
    <>
      {Object.keys(NET_WORTH_MODAL.sections).map((section) => {
        return (
          <Accordion
            sx={{
              border: '1px solid gray',
              marginTop: 1,
              marginBottom: 1,
            }}
            style={{ borderRadius: '20px' }}
            expanded={section === expandedSection}
            onClick={() => {
              setExpandedSection(section);

              mixpanel.track('Assets and Net Worth Modal', {
                user_id: user.id,
                distinct_id: user.id,
                section,
              });
              if (section === NET_WORTH) {
                setAssetWorthModalInfoState((prevState) => {
                  return {
                    ...prevState,
                    [section]: {
                      ...prevState[section],
                      [NET_WORTH]: prevState[section][ASSETS] - prevState[section][LIABILITIES],
                    },
                  };
                });
              }
            }}
            key={section}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              className="asset-modal-accordion-summary"
            >
              {section}
            </AccordionSummary>
            <AccordionDetails sx={{ overflow: 'auto', maxHeight: 400 }}>
              {NET_WORTH_MODAL.sections[section].rows.map((row, index) => (
                <div key={index} className="asset-networth-modal-row-content">
                  {row.map((column) => {
                    const element = getFieldType({
                      type: column.fieldType,
                      options: column?.options || [],
                      value: getValue(section, column),
                      fieldEnumType: column.type || TEXT,
                      textContent: column.text,
                      helperText: column.helperText || '',
                      name: column.name,
                      onChange: (e) => {
                        setAssetWorthModalInfoState((prevState) => {
                          // TO DO - Clean up this switch statement
                          switch (section) {
                            case ASSETS:
                              const previousVal = Number(prevState[section][column.label]);
                              const currentTotalAsset = Number(prevState[section][TOTAL_ASSETS]);

                              const diff = Number(e.target.value || 0) - previousVal;
                              const newTotalAsset = currentTotalAsset + diff;

                              return {
                                ...prevState,
                                [section]: {
                                  ...prevState[section],
                                  [column.label]: e.target.value,
                                  [TOTAL_ASSETS]: newTotalAsset,
                                },
                                [NET_WORTH]: {
                                  ...prevState[NET_WORTH],
                                  [ASSETS]: newTotalAsset,
                                  [NET_WORTH]:
                                    Number(newTotalAsset || 0) -
                                    Number(prevState[NET_WORTH][LIABILITIES] || 0),
                                },
                              };

                            case LIABILITIES:
                              const previousLiabilityVal = Number(
                                prevState[section][column.label] || 0,
                              );
                              const currentTotalLiability = Number(
                                prevState[section][TOTAL_LIABILITIES],
                              );

                              const diff_LIABILITY = e.target.value - previousLiabilityVal;
                              const newTotalLiability = currentTotalLiability + diff_LIABILITY;
                              const prevTotalAsset = Number(prevState[section][ASSETS] || 0);

                              return {
                                ...prevState,
                                [section]: {
                                  ...prevState[section],
                                  [column.label]: e.target.value,
                                  [TOTAL_LIABILITIES]: newTotalLiability,
                                },
                                [NET_WORTH]: {
                                  ...prevState[NET_WORTH],
                                  [LIABILITIES]: newTotalLiability,
                                  [NET_WORTH]: prevTotalAsset - Number(newTotalLiability || 0),
                                },
                              };

                            default:
                              return {
                                ...prevState,
                              };
                          }
                        });
                      },
                    });

                    const fullWidthOnMobile = column.fullWidthOnMobile ? FULL_WIDTH : '';
                    let fieldWrappClass;

                    // TO DO - Refactor this to make cleaner
                    if (row.length === 2) {
                      fieldWrappClass = DOUBLE_FIELDS_WRAPPER;
                    } else if (row.length === 1) {
                      fieldWrappClass = SINGLE_FIELD_WRAPPER;

                      // TO DO - better naming for this
                      fieldWrappClass +=
                        column.text === NET_WORTH ? ' ' + NET_WORTH_ADDING_PADDING : '';
                    } else if (row.length === 3) {
                      fieldWrappClass = TRIPLE_FIELDS_WRAPPER;
                    }

                    return (
                      // clx css eventually
                      <div
                        key={column.label + ' ' + column.placeholder}
                        className={fieldWrappClass + ' ' + fullWidthOnMobile}
                      >
                        {column.label && (
                          <p className="assets-and-worth-field-label" style={{ ...column?.style }}>
                            {column.label}
                          </p>
                        )}
                        <FormControl sx={{ width: `100%`, pl: 0.5 }}>{element}</FormControl>
                      </div>
                    );
                  })}
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        );
      })}
      <ModalButtonRow
        onCancel={handleClose}
        onConfirm={() => onConfirm({ assetWorthInfo: assetWorthModalInfoState })}
      />
    </>
  );
};
